import { createContext } from 'react';
import { IInstitution } from '../../shared-interfaces/Contexts/IInstitution';
import { IInstitutionProducts } from '../../shared-interfaces/Contexts/IInstitutionProducts';
import { IInstitutionSettings } from '../../shared-interfaces/Contexts/IInstitutionSettings';

interface ICustomWindow extends Window {
  initialAppState?: any;
}

const customWindow: ICustomWindow = window;

const InstitutionContext = createContext({
  institution: customWindow.initialAppState.institution as IInstitution,
  products: customWindow.initialAppState.products as IInstitutionProducts,
  settings: customWindow.initialAppState
    .institutionSettings as IInstitutionSettings,
});

export const hasFeature = (feature: number | string) => {
  try {
    const beaconProductFeatures = customWindow.initialAppState.products.find(
      (x: any) => x.name.toLowerCase() === 'beacon',
    ).features;
    if (typeof feature === 'string') {
      const lFeature = feature.toLowerCase();
      return (
        beaconProductFeatures.find(
          (x: any) => x.name.toLowerCase() === lFeature,
        ) != null
      );
    } else {
      return beaconProductFeatures.find((x: any) => x.id === feature);
    }
  } catch {
    return false;
  }
};

export const hasProduct = (product: number | string) => {
  try {
    if (typeof product === 'string') {
      const lProduct = product.toLowerCase();
      return (
        customWindow.initialAppState.products.find(
          (x: any) => x.name.toLowerCase() === lProduct,
        ) != null
      );
    } else {
      return (
        customWindow.initialAppState.products.find(
          (x: any) => x.id === product,
        ) != null
      );
    }
  } catch {
    return false;
  }
};

export default InstitutionContext;
